import React from 'react';
import 'whatwg-fetch';
const BingApi = {};
const bingKey = process.env.REACT_APP_BING_MAPS_KEY;
const bingRoutesUrl = "https://dev.virtualearth.net/REST/v1/Routes/Truck?key=".concat(bingKey);
const bingLocationUrl = 'https://dev.virtualearth.net/REST/v1/Locations';
function handleResponse(response) {
  let result = {};
  if (response.status === 200) {
    result = response.json();
  }
  return result;
}
function processGecodeAddressResponse(response) {
  if (response.resourceSets) {
    return response.resourceSets[0].resources[0].point.coordinates;
  }
  return null;
}
function buildGeocodeAddressParams(address) {
  const mappedParams = {
    adminDistrict: address.region,
    addressLine: address.street_address,
    countryRegion: address.country,
    locality: address.city,
    postalCode: address.region_code,
    o: 'json',
    key: bingKey
  };
  return Object.entries(mappedParams).map(e => e.join('=')).join('&');
}
function processDistanceResponse(response) {
  const resources = response.resourceSets[0].resources[0];
  const routeLegs = resources.routeLegs;
  const finalResult = {
    totalDistance: resources.travelDistance.toFixed(4),
    totalDuration: parseInt(resources.travelDuration / 60, 10),
    routeLegs: []
  };
  for (let i = 0; i < routeLegs.length; i += 1) {
    finalResult.routeLegs.push({
      distance: routeLegs[i].travelDistance.toFixed(4),
      duration: parseInt(routeLegs[i].travelDuration / 60, 10)
    });
  }
  return finalResult;
}
function buildDistanceParams(waypoints) {
  return JSON.stringify({
    waypoints,
    distanceUnit: 'miles',
    isViaPoint: true,
    travelMode: 'driving',
    vehicleSpec: {
      vehicleSemi: 'true',
      vehicleWeight: 80000
    }
  });
}
function getData(url, method, requestBody, format) {
  let params = {
    method,
    headers: {
      'Content-Type': 'application/json'
    }
  };
  if (requestBody) {
    params = {
      ...params,
      body: requestBody
    };
  }
  return fetch(url, params).then(handleResponse).then(format).catch(error => error);
}
BingApi.distanceBetweenStops = async waypoints => {
  const requestBody = buildDistanceParams(waypoints);
  return getData(bingRoutesUrl, 'POST', requestBody, processDistanceResponse);
};
BingApi.geocodeAddress = async address => {
  const requestUrl = "".concat(bingLocationUrl, "?").concat(buildGeocodeAddressParams(address));
  return getData(requestUrl, 'GET', null, processGecodeAddressResponse);
};
export default BingApi;